/** @format */
import React from 'react';
import { MutiLineEllipsisWrapper, InlineEllipsisWrapper } from './styles';

const TextEllipsis = ({ children, width, lineLimit = 1 }) => {
	if (lineLimit < 2) {
		return (
			<InlineEllipsisWrapper width={width}>{children}</InlineEllipsisWrapper>
		);
	} else {
		return (
			<MutiLineEllipsisWrapper width={width} line={lineLimit}>
				{children}
			</MutiLineEllipsisWrapper>
		);
	}
};

export default React.memo(TextEllipsis);
